import gql from 'fraql'

const brandQueries = {
  CURRENT_REST_POINT: gql`
    query {
      accountRestpoint {
        id,
        address,
        location,
        CAA: courierAutoAssign
      }
    }
  `
}
export default brandQueries



// WEBPACK FOOTER //
// ./src/graphql/brand.js